var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7856 0H1.2144C0.5434 0 0 0.5434 0 1.2144V20.7856C0 21.4566 0.5434 22 1.2144 22H11.7502V13.4805H8.8836V10.1607H11.7502V7.711C11.7502 4.8686 13.486 3.322 16.0215 3.322C17.2359 3.322 18.2787 3.4122 18.5834 3.4529V6.4229H16.8256C15.4462 6.4229 15.18 7.0785 15.18 8.0399V10.1596H18.4679L18.0389 13.4794H15.1789V22H20.7856C21.4566 22 22 21.4566 22 20.7856V1.2144C22 0.5434 21.4566 0 20.7856 0Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.17e0352b9a3532204746ce3864bb3241.svg";
export { ForwardRef as ReactComponent };